// --- Our Modules --------------------------------------------------------------------------------
import type { TyRole } from "@/types";
// --- Logic --------------------------------------------------------------------------------------
/**
 * Mirrors the backend's `canManageRole`: each role controls the one below it and no further. Hiding an
 * action the API would refuse is courtesy, not security — the server checks the same thing.
 */
export function canManageRole(actor: TyRole | null, target: TyRole | null): boolean {
    if (target === "owner" || !target) return false;
    if (actor === "owner") return true;
    if (actor === "manager") return target === "member";
    return false;
}
